function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { ErrorSeverity } from '../../error';
export var BufferAnalyser = /*#__PURE__*/ function() {
    "use strict";
    function BufferAnalyser(severityConfig, playoutData, errorHandler, logger) {
        _class_call_check(this, BufferAnalyser);
        _define_property(this, "playoutData", void 0);
        _define_property(this, "errorHandler", void 0);
        _define_property(this, "severity", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "lastSeenGaps", void 0);
        this.playoutData = playoutData;
        this.errorHandler = errorHandler;
        this.lastSeenGaps = {};
        this.logger = logger.withContext('BGAP');
        var possibleValues = [
            ErrorSeverity.Warning,
            ErrorSeverity.Fatal
        ];
        if (severityConfig && !possibleValues.includes(severityConfig)) {
            this.logger.warn("Invalid value for `debugConfig.bufferGapDetectionSeverity` - expected one of [".concat(possibleValues.join(', '), "] but received ").concat(severityConfig));
            return;
        }
        this.severity = severityConfig;
    }
    _create_class(BufferAnalyser, [
        {
            key: "createBufferedInfoString",
            value: function createBufferedInfoString(bufferedInfo) {
                var _this = this;
                return Object.entries(bufferedInfo).filter(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], range = _param[1];
                    return Boolean(range);
                }).reduce(function(acc, currentBuffer) {
                    var _currentBuffer = _sliced_to_array(currentBuffer, 2), bufferType = _currentBuffer[0], range = _currentBuffer[1];
                    var bufferedRangesString = _this.createTimeRangesString(range, bufferType);
                    return "".concat(acc, " Buffered Ranges: ").concat(bufferedRangesString, " \n");
                }, "Buffer Information: \n");
            }
        },
        {
            key: "executeBufferGapDetection",
            value: function executeBufferGapDetection(bufferedInfo) {
                var _this = this;
                if (this.severity && bufferedInfo) {
                    Object.entries(bufferedInfo).forEach(function(param) {
                        var _param = _sliced_to_array(param, 2), bufferType = _param[0], currentBufferedRanges = _param[1];
                        var currentGaps = _this.findGaps(currentBufferedRanges);
                        if (currentGaps.length === 0) {
                            _this.lastSeenGaps[bufferType] = [];
                            return;
                        }
                        var lastSeenGapsForType = _this.lastSeenGaps[bufferType] || [];
                        if (_this.bufferedRangesEqual(lastSeenGapsForType, currentGaps)) {
                            return;
                        }
                        _this.lastSeenGaps[bufferType] = currentGaps;
                        var cdnUrl = _this.playoutData.cdns[0].url;
                        var urlMessage = "[".concat(bufferType, "] gap detected on ").concat(cdnUrl);
                        var bufferedRangesInfo = "Buffered ranges ".concat(_this.createTimeRangesString(currentBufferedRanges, bufferType));
                        _this.logger.warn(urlMessage);
                        _this.logger.warn(bufferedRangesInfo);
                        var gapsInfo = _this.createTimeRangesString(currentGaps, bufferType);
                        _this.errorHandler({
                            message: "Gap detected ".concat(gapsInfo, " on ").concat(cdnUrl),
                            severity: _this.severity
                        });
                    });
                }
            }
        },
        {
            key: "bufferedRangesEqual",
            value: function bufferedRangesEqual(bufferedRanges1, bufferedRanges2) {
                if (bufferedRanges1.length !== bufferedRanges2.length) {
                    return false;
                }
                for(var i = 0; i < bufferedRanges1.length; i++){
                    var bufferedRange1 = bufferedRanges1[i];
                    var bufferedRange2 = bufferedRanges2[i];
                    if (bufferedRange1.start.toFixed(3) !== bufferedRange2.start.toFixed(3) || bufferedRange1.end.toFixed(3) !== bufferedRange2.end.toFixed(3)) {
                        return false;
                    }
                }
                return true;
            }
        },
        {
            key: "findGaps",
            value: function findGaps(bufferedRanges) {
                if (!bufferedRanges || bufferedRanges.length <= 1) {
                    return [];
                }
                var gaps = [];
                for(var i = 0; i < bufferedRanges.length - 1; i++){
                    var currentBufferedRange = bufferedRanges[i];
                    var nextBufferedRange = bufferedRanges[i + 1];
                    gaps.push({
                        start: currentBufferedRange.end,
                        end: nextBufferedRange.start
                    });
                }
                return gaps;
            }
        },
        {
            key: "createTimeRangesString",
            value: function createTimeRangesString(bufferedRanges, type) {
                return bufferedRanges.reduce(function(acc, currentRange, index) {
                    var start = currentRange.start.toFixed(3);
                    var end = currentRange.end.toFixed(3);
                    return "".concat(acc, " ").concat(index, ": ").concat(start, " - ").concat(end, ",");
                }, "[".concat(type, "]: "));
            }
        }
    ]);
    return BufferAnalyser;
}();

//# sourceMappingURL=buffer-analyser.js.map